<div class="h-full w-full">
  <app-tool-loader [isLoading]="!_load">
    <form [formGroup]="form.formGroup" class="m-2">

      <!-- Name Row -->
      <div class="flex justify-between items-center gap-2 mb-2">
        <div class="flex flex-col w-[300px]">
          <label for="load-name">Load Name</label>
          <input 
            id="load-name" 
            type="text" pInputText 
            [formControlName]="form.formControlNames.name"
            [class.pointer-events-none]="form.formGroup.controls.name.value == 'Initial Condition'"
            [class.opacity-50]="form.formGroup.controls.name.value == 'Initial Condition'"
           />
        </div>

        <div class="flex space-x-2">
          <app-validation-error [isValid]="isControlInvalid(form.formGroup, 'internalPressureProfile')"
            [errorMsg]="getControlErrors(form.formGroup, 'internalPressureProfile')"/>

          <p-button class="outlined-button" label="Save" size="small" severity="success" outlined
            [disabled]="form.formGroup.invalid || form.formGroup.disabled || form.formGroupErrors" icon="pi pi-check"
            (click)="form.formGroup.dirty ? manualSave$$.next() : cancelEdit$.next()">
          </p-button>

          <p-button class="outlined-button" label="Cancel" icon="pi pi-times" size="small" severity="danger" outlined (click)="cancelEdit$.next()">
          </p-button>
        </div>
      </div>

      <!-- Load Case Partials-->
      <div class="grid grid-cols-11 gap-4">
        <div class="col-span-5">
          <app-internal-pressure-profiles [isReadOnly]="isReadOnly" #ipp
            [formControlName]="form.formControlNames.internalPressureProfile" [currentString]="currentString"
            [cement]="cement" [thermalOperations]="thermalOperations" [wellType]="wellType"
            [userUnits]="userUnits" [wellTd]="wellTd" [porePressures]="porePressures" [fracPressures]="fracPressures"
            [tubulars]="tubulars" [loadCaseIndex]="form.formGroup.value.index"
          ></app-internal-pressure-profiles>
        </div>
        <div class="col-span-3">
          <app-external-pressure-profiles [isReadOnly]="isReadOnly" #epp
            [formControlName]="form.formControlNames.externalPressureProfile" [shoeDepth]="shoeDepthTvd"
            [currentString]="currentString" [cement]="cement" [porePressures]="porePressures" [fracPressures]="fracPressures"
            [thermalOperations]="thermalOperations" [userUnits]="userUnits"[tubulars]="tubulars"
            [wellTd]="wellTd" [loadCaseIndex]="form.formGroup.value.index"
          ></app-external-pressure-profiles>
        </div>
        <div class="col-span-3">
          @if (form.formGroup.errors?.customTempAboveInfluxDepth) {
            <p class="validation-error">Temperature Profile must be specified to Influx Depth</p>
          }
          
          <app-temperature-profiles [isReadOnly]="isReadOnly" #tp
            [formControlName]="form.formControlNames.temperatureProfile" [currentString]="currentString"
            [loadName]="_load?.name" [thermalOperations]="thermalOperations" [wellType]="wellType"
            [userUnits]="userUnits" [wellTd]="wellTd" [tubulars]="tubulars"
          ></app-temperature-profiles>
        </div>
      </div>

    </form>
  </app-tool-loader>

</div>